(() => {
  'use strict';

  const controllerKey = '__vrsProductDetailsColumnController';
  const desktopQuery = '(min-width: 769px)';

  if (window[controllerKey]) {
    window[controllerKey].refresh();
    return;
  }

  const mediaQuery = window.matchMedia(desktopQuery);
  let state = null;
  let refreshFrame = 0;
  let resizeFrame = 0;

  function getDetailsContainer(detailsSection) {
    return Array.from(detailsSection.children).find((child) => (
      child.classList && child.classList.contains('container')
    )) || detailsSection.querySelector('.container');
  }

  function findDetailBlock(blocks, selector) {
    return blocks.find((block) => (
      block.matches(selector) || block.querySelector(selector)
    ));
  }

  function orderDetailBlocks(detailsSection) {
    const container = getDetailsContainer(detailsSection);
    if (!container) return;

    const blocks = Array.from(container.children).filter((child) => (
      child.nodeType === Node.ELEMENT_NODE
    ));

    const highlightBlock = blocks.find((block) => (
      block.classList.contains('product-details__highlight-grid')
    ));
    const brandBlock = findDetailBlock(blocks, '.vrs-brand-profile');
    const tabsBlock = blocks.find((block) => (
      block.querySelector('tabbed-content') || block.querySelector('.tablist')
    ));
    const resourcesBlock = findDetailBlock(blocks, '.vrs-product-resources');

    [highlightBlock, brandBlock, tabsBlock, resourcesBlock]
      .filter(Boolean)
      .forEach((block) => container.appendChild(block));

    container.classList.add('vrs-product-details__ordered');
  }

  function locateSections() {
    const mainSection = document.querySelector('.cc-main-product');
    const detailsSection = document.querySelector('.cc-product-details');
    const mediaColumn = mainSection && mainSection.querySelector('.product-media');

    if (!mainSection || !detailsSection || !mediaColumn) return null;
    return { mainSection, detailsSection, mediaColumn };
  }

  function restoreDetails(currentState) {
    if (!currentState) return;

    const { anchor, detailsSection, mainSection, mediaColumn } = currentState;
    if (anchor.isConnected && detailsSection.isConnected) {
      const originalParent = anchor.parentNode;
      if (
        originalParent
        && (
          detailsSection.parentNode !== originalParent
          || detailsSection.previousSibling !== anchor
        )
      ) {
        originalParent.insertBefore(detailsSection, anchor.nextSibling);
      }
    }

    detailsSection.classList.remove('vrs-product-details--in-media');
    mainSection.classList.remove('vrs-product-details-in-left-column');
    mediaColumn.classList.remove('vrs-product-media--with-details');
  }

  function destroyState() {
    if (!state) return;
    restoreDetails(state);
    if (state.anchor.isConnected) state.anchor.remove();
    state = null;
  }

  function createState(parts) {
    const anchor = document.createElement('span');
    anchor.hidden = true;
    anchor.setAttribute('aria-hidden', 'true');
    anchor.setAttribute('data-vrs-product-details-anchor', '');
    parts.detailsSection.parentNode.insertBefore(anchor, parts.detailsSection);

    state = {
      ...parts,
      anchor
    };
  }

  function notifyLayoutChange() {
    if (resizeFrame) cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('vrs:product-details-relocated'));
    });
  }

  function refresh() {
    refreshFrame = 0;
    const parts = locateSections();
    if (!parts) return;

    if (
      !state
      || state.mainSection !== parts.mainSection
      || state.detailsSection !== parts.detailsSection
      || state.mediaColumn !== parts.mediaColumn
      || !state.anchor.isConnected
    ) {
      destroyState();
      createState(parts);
    }

    orderDetailBlocks(state.detailsSection);

    let moved = false;
    if (mediaQuery.matches) {
      if (state.detailsSection.parentNode !== state.mediaColumn) {
        state.mediaColumn.appendChild(state.detailsSection);
        moved = true;
      }

      state.detailsSection.classList.add('vrs-product-details--in-media');
      state.mainSection.classList.add('vrs-product-details-in-left-column');
      state.mediaColumn.classList.add('vrs-product-media--with-details');
    } else {
      const originalParent = state.anchor.parentNode;
      if (
        originalParent
        && (
          state.detailsSection.parentNode !== originalParent
          || state.detailsSection.previousSibling !== state.anchor
        )
      ) {
        originalParent.insertBefore(state.detailsSection, state.anchor.nextSibling);
        moved = true;
      }

      state.detailsSection.classList.remove('vrs-product-details--in-media');
      state.mainSection.classList.remove('vrs-product-details-in-left-column');
      state.mediaColumn.classList.remove('vrs-product-media--with-details');
    }

    if (moved) notifyLayoutChange();
  }

  function scheduleRefresh() {
    if (refreshFrame) cancelAnimationFrame(refreshFrame);
    refreshFrame = requestAnimationFrame(refresh);
  }

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', scheduleRefresh);
  } else {
    mediaQuery.addListener(scheduleRefresh);
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  document.addEventListener('shopify:section:select', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }

  window[controllerKey] = {
    refresh: scheduleRefresh,
    destroy: destroyState
  };
})();
